import React, { useContext, useEffect, useState } from "react";
import { server } from "../../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../../store/stateFunctions";
import Swal from "sweetalert2";
import { AiFillDelete } from "react-icons/ai";
import withReactContent from "sweetalert2-react-content";
import { NavLink } from "react-router-dom";
import { PAYMENT_KEY } from "../../../config";
import configContext from "../../../context/configContext/configContext";

const swalalert = withReactContent(Swal);

const StudentEventEnquiries = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [yuvadata, setYuvaData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getIndEventEnquiry();
    getEventInquiry();
  }, []);

  // Get
  const getIndEventEnquiry = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/event/studenteventappl", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getEventInquiry = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/event/admstudenteventappl", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setYuvaData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // Delete
  const deleteIndEnquiry = (data) => {
    console.log("data:", data);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.shop_name} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/event/deleteeventreg/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getIndEventEnquiry();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // Delete
  const deleteAdminEnquiry = (yuvadata) => {
    console.log("data:", yuvadata);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${yuvadata.shop_name} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/event/deleteeventreg/${yuvadata.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getEventInquiry();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // Update Status
  const payment = async (id) => {
    const data = await fetch(
      `http://localhost:7001/api/event/proceed-to-checkout/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: user.authToken,
        },
      }
    ).then((t) => t.json());

    console.log(data);

    //options
    const options = {
      key: PAYMENT_KEY,
      currency: data.currency,
      amount: data.amount,
      description: "wallet transaction",
      Image: "http://localhost:7001/logo_jpeg",
      order_id: data.id,
      // handler: toast.success("Payment Done"),
      handler: function (response) {
        alert("PAYMENT ID:" + response.razorpay_payment_id);
        alert("ORDER ID:" + response.razorpay_order_id);
        toast.success("Payment Done");
      },
      prefill: {
        //fill out the detail
        name: "Gauri",
        email: "gauri@gmail.com",
        contact: "9322695526",
      },
    };
    //display the window on button click
    const paymentObject = new window.Razorpay(options);

    paymentObject.open();
  };

  return (
    <div>
      <h3 className="text-center my-2 text-uppercase">Registered Events</h3>
      <div className=" row">
        {/* <div className="col-md-4 text-end my-1">
          <select className="form-control text-uppercase" name="" id="">
            <option value="">Gyms</option>
            <option value="">Cafe's</option>
            <option value="">Lodge</option>
            <option value="">Bakery</option>
            <option value="">Classes</option>
            <option value="">Library</option>
            <option value="">Travels</option>
            <option value="">Laundry</option>
            <option value="">Garriage</option>
            <option value="">Medicals</option>
            <option value="">Restaurants</option>
            <option value="">Stationery</option>
            <option value="">Cyber Cafe</option>
            <option value="">Event Decors</option>
            <option value="">PG/Hostels</option>
            <option value="">Doctors/Clinic</option>
            <option value="">Salons/Parlours</option>
            <option value="">Mess/Parcel Points</option>
          </select>
        </div>
        <div className="col-md-4 text-start my-1"></div>
        <div className="col-md-4 text-start my-1">
          <input
            type="search"
            name=""
            id=""
            className="form-control"
            placeholder="Search"
          />
        </div> */}
      </div>
      <div className="container ">
        <div className="row  shadow-sm text-center mb-3">
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/myeventenquiries">
                Event Enquiries
              </NavLink>
            </h5>
          </div>
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/myenquiries">
                Merchant Enquiries
              </NavLink>
            </h5>
          </div>
          {/* <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/ambassadorentry">
                Ambassador Enquiries
              </NavLink>
            </h5>
          </div> */}
        </div>
      </div>
      <div className="container" style={{ overflow: "scroll" }}>
        <table className="table table-striped border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Event Title</th>
              <th scope="col">Event Date</th>
              <th scope="col">Address</th>
              <th scope="col">Location Link</th>
              <th scope="col">Category</th>
              <th scope="col">Pay Fees</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {data.length
              ? data?.map((item, index) => {
                  return (
                    <tr key={item.id}>
                      <th scope="row">{index + 1}</th> <td>{item.title}</td>
                      <th>{item.event_date}</th>
                      <td>{item.address}</td>
                      <td>
                        <a href={item.location}>{item.location}</a>
                      </td>
                      <td>{item.category}</td>
                      <td>
                        <button
                          type="submit"
                          className="my-2 banner text-white rounded-3 p-2 border-0"
                          onClick={() => payment(item.id)}
                        >
                          Pay
                        </button>
                      </td>
                      <td>
                        <div className="btn banner text-white">
                          <AiFillDelete
                            onClick={() => deleteIndEnquiry(item)}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              : null}
            {yuvadata.length
              ? yuvadata.map((item, index) => {
                  return (
                    <tr key={item.id}>
                      <th scope="row">{index + 1}</th>
                      <td>{item.title}</td>
                      <th>{item.event_date}</th>
                      <td>{item.address}</td>
                      <td>
                        <a href={item.location}>{item.location}</a>
                      </td>
                      <td>{item.category}</td>
                      <td>
                        <button
                          type="submit"
                          className="my-2 banner text-white rounded-3 p-2 border-0"
                          onClick={() => payment(item.id)}
                        >
                          Pay
                        </button>
                      </td>
                      <td>
                        <div className="btn banner text-white">
                          <AiFillDelete
                            onClick={() => deleteAdminEnquiry(item)}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentEventEnquiries;
